import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { TestRegistrationComponent } from './test-registration/test-registration.component';
import { TestPatientsComponent } from './test-patients.component';
import { TestAgentComponent } from './test-agent/test-agent.component';

const routes: Routes = [
  { path: 'registration', component: TestRegistrationComponent, data: { title: 'Test Registration' } },
  { path: 'agents', component: TestAgentComponent, data: { title: 'Test Agents' } },
  { path: '**', component: TestPatientsComponent, data: { title: 'Test Patients' } },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class TestPatientsRoutingModule {}
